<template>
  <div class="blog-card" @click="openBlog(blog)">
    <div class="blog-pic">
      <img :alt="blog.title" :src="url + blog.featured_image" > 
    </div>
    <div class="blog-details">
      <div class="blog-title">{{blog.title}}</div>
      <div class="blog-time">{{calculateTimeago(blog.created_at)}}</div>
      <div class="blog-slug">{{blog.slug}}</div>
      <div class="filter-tags">
        <div class="tag">{{blog.blog_type}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import TimeAgo from 'javascript-time-ago';

export default {
  name: 'BlogCard',

  props: {
    blog: {},
  },

  methods: {
    openBlog(blog) {
      this.$router.push({ name: 'BlogPage', params: { 'blog': blog, 'id': blog.url_name } })
    },

    calculateTimeago(lastDate) {
      if (lastDate) {
        const date = new Date(lastDate.split(' +')[0]);
        const timeAgo = new TimeAgo('en-US')
        return timeAgo.format(date, 'mini') + ' ago';
      }
      return '-';
    },
  },

  computed: {
    url() {
      let url = window.location.origin;
      if (url === "http://localhost:8080") {
        url = "http://localhost:3000";
      }
      return url;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.blog-card {
  // height: 420px;
  border: 1px solid $sec7;
  background: #FFF;
  border-radius: $border-radius-large;
  overflow: hidden;

  .blog-pic {
    width: 100%;
    background: #000;
    aspect-ratio: 2/1;
    position: relative;

    img {
      width: 100%;
      object-fit: cover;
      aspect-ratio: 2/1;
      position: absolute;
    }
  }
  .blog-details {
    padding: 16px;
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    .filter-tags {
      justify-content: start;
      align-items: end;
      flex: 1;

      .tag:hover {
        background: $sec7;
      }
    }
    .blog-title {
      font-size: 20px;
      font-weight: 500;
      padding-bottom: $spacing-small;
      color: $sec0;
    }
    .blog-slug {
      font-size: 14px;
      color: $sec2;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2; /* number of lines to show */
              line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-bottom: 8px;
    }
    .blog-time {
      color: $sec3;
      font-size: 14px;
      margin-bottom: 8px;
    }

  }
}
.blog-card:hover {
  cursor: pointer;
  background: #F7F7F7;
}

.filter-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  justify-content: center;
  align-items: center;

  .tag {
    border-radius: 100px;
    background: $sec7;
    padding: 6px 12px;
    color: $sec2;
    cursor: pointer;
    font-size: $font-size-small;
    text-transform: uppercase;
  }
  .tag:hover {
    background: $sec6;
  }

  .selected-tag {
    background: $blue;
    color: #FFF;
  }
  .selected-tag:hover {
    background: $blue;
  }
}

@media all and (min-width: 750px) {
  .blog-card .blog-details {
    .blog-slug {
      font-size: 16px;
    }

    .blog-time {
      font-size: 16px;
    }
  }
}
</style>